import { useState } from "react";
import { Copy } from "lucide-react";

export function GmailIdCopy({ gmailId }: { gmailId?: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!gmailId) return;
    await navigator.clipboard.writeText(`rfc822msgid:${gmailId}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  if (gmailId?.startsWith('setup-file:')) return null;

  if (!gmailId) {
    return <span className="text-text dark:text-text-dark">no email id</span>;
  }

  return (
    <button
      onClick={handleCopy}
      className="flex items-center gap-1 text-sm text-blue-600 dark:text-blue-400 hover:underline"
    >
      <Copy className="w-4 h-4" />
      {copied ? "Copied!" : "Copy email id"}
    </button>
  );
}
